import workers from "./workers";

export default workers;
